import { defineStore } from 'pinia'
import { sendApi } from '@/utils/api'
import { BASE_URL } from '@/config'
function dataRender(data){
return data.map(item => ({
    id: item.id,
    title: item.title,
    body: item.body,
    url:item.url,
    is_read:item.is_read,
    read_at:item.read_at,
    create_at:item.create_at,
    updated_at:item.updated_at
  }))
}
export const useNotificationStore = defineStore('notification', {
  state: () => ({
    cards: [],
    hasMore: false,
    isLoaded: false,
    unreadCount: 0,
  }), 
  actions: {
    async fetchNotifications (limit = 10, offset = 0, append = false) {
      try{
        const res = await sendApi({
          action: 'get_notifications',
          control: 'user', 
          data: { limit, offset }
        })
        if (res.status === 'success') {
          const newproducts = dataRender(res.data);
          const filteredproducts = newproducts.filter(notification => notification.id)
          if(append){
            this.cards = [...this.cards, ...filteredproducts]
          }
          this.isLoaded = true
          this.unreadCount = res.counts
          this.hasMore = res.has_more ?? false
          return filteredproducts
        }
        return []
      } catch (err) {
        console.log(err);
      }
    },
    async readMsg (id) {
      try{
        const res = await sendApi({
          action: 'read_notifications',
          control: 'user',
          data: id,
        })
        return res.status === 'success'
      }catch(e){
        console.error(e)
        return false
      }
    },
    markAsRead(id) {
      const notif = this.cards.find(n => n.id === id)
      if (notif && notif.is_read === 'dont') {
        notif.is_read = 'seen'
        this.unreadCount = this.cards.filter(n => n.is_read === 'dont').length
      }
    },
    callNotification(title, body) {
        if (Notification.permission === 'granted') {
            const notification = new Notification(title, {
                body,
                icon: BASE_URL + '/assets/images/logo.png',
            })
            notification.onclick = () => {
              window.focus()
              notification.close()
            }
            notification.onshow = () => {
              new Audio(BASE_URL + '/assets/song/notif.mp3').play()
            }
            notification.vibrate = [true]
        }
    },
    requestAllowNotification(){
      if (Notification.permission !== 'granted') {
        Notification.requestPermission()
      }
    }
  }
})